<template>
    <div class="application-tree">
        <el-header  v-if="isFilter === true" height="40px;line-height: 40px;">
            <el-input
                placeholder="输入应用进行过滤"
                v-model="filterText">
            </el-input>
        </el-header>
        <el-tree
            v-if="popover === false"
            highlight-current
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="idExpandedArr"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            @node-click="handleTreeNode"
            :filter-node-method="filterNode"
            :class="defaultClass"
            ref="appTree"
          >
            <span class="custom-tree-node" slot-scope="{ node,treeData }">
                   <span><i :class="getTreeNodeClass(node)"></i>{{ node.label }}</span>
            </span>
        </el-tree>

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="200"
            trigger="focus"
            @after-enter='treeShow'>
            <el-tree
                highlight-current
                ref="tree"
                node-key="id"
                :current-node-key="selectNodeId"
                :default-expanded-keys="idExpandedArr"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                :class="defaultClass"
                @node-click="handleTreeNode"
            />
            <el-input slot="reference" readonly v-model="popoverTreeLable"></el-input>
        </el-popover>
    </div>
</template>

<script>
    import { getApplicationTreeList } from '@/data-model';
    export default {
        name: 'ApplicationTree',
        data () {
            return {
                idExpandedArr: [],
                filterText: '',
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: ''
            };
        },
        watch: {
            filterText (val) {
                this.$refs.appTree.filter(val);
            }
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                // type: [ Number, String ]
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            },
            defaultExpand: {
                type: Boolean,
                default: false
            },
            isFilter: {
                type: Boolean,
                default: true
            },
            defaultClass: {
                type: String,
                default: 'dictionary-tree'
            }
        },
        created () {
            this._initPage().then(val => {
                // 初始化默认展开到第二级
                if (this.treeData && this.treeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.treeData[0].id);
                }
            });
        },
        methods: {
            initLabel () {
                this.popoverTreeLable = '';
            },
            filterNode (value, data) {
                if (!value) {
                    return true;
                }
                return data.label.indexOf(value) !== -1;
            },
            getTreeNodeClass (node) {
                return node.data.treeIconClass;
            },
            async _initPage () {
                await this._getTreeData();
                this._setSelectedNode();
            },
            async _getTreeData () {
                let applicationTreeList = [];
                if (this.data) {
                    applicationTreeList = this.data;
                } else {
                    applicationTreeList = await getApplicationTreeList({rootId: this.rootId});
                }
                this.treeData = applicationTreeList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = this.selectedNode.id;
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.selectNodeId);
                }
            },
            _refreshSelectedNode (node) {
                if (node) {
                    this.setNode(node);
                    this.$nextTick().then(() => {
                        this.$refs.appTree.setCurrentKey(this.selectNodeId);
                    });
                }
            },
            setNode (node) {
                this.popoverTreeLable = node.title;
                this.selectNodeId = node.value;
                this.idExpandedArr = [];
                this.idExpandedArr.push(this.selectNodeId);
            },
            handleTreeNode (data, node, tree) {
                this.popoverTreeLable = data.label;
                this.$emit('nodeClick', data, node, tree);
            },
            setTreeStatus () {
                this.$refs.tree.setCurrentNode(2);
            },
            treeShow () {
                // console.log('treeShow');
                // this.setTreeStatus();
                this.$emit('treeShow');
            }
        }
    };
</script>
<style lang="less">
    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background-color: #51a5e8;
        color: #FFFFFF;
    }
    .el-tree-node__children{
        overflow-x: auto !important;
    }
    .application-tree-pop{
    	max-height: 60vh;
    	overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/ApplicationTree/ApplicationTree.vue